export default __webpack_public_path__ + "static/media/Fauld of the Scattered Gods.3944b283.jpg";